import {Link} from 'react-router-dom';
import {useParams} from 'react-router-dom';
import {useState,useEffect} from 'react';
import axios from "axios";
import {baseUrl, userLocation, ipAddress, userName, formatDateTime} from '../Univ.js'
function AccountMenu(){
    return (
        <section className="container mt-4">
            <div className="row nurseInpatient">
                <div className='col-md-12 col-12'>
                    <div className="row">
                    <div className="col-md-12 company-info">
                    <div className="panel panel-primary">
                    <div className="panel-heading">
                    <h4 className="panel-title" >Financial Accounting</h4>
                    </div>
                    </div>
                    </div>
                    </div>

                    <div className="row">
                    <div className="col-md-12 company-info">
                    <div className="btn-group">
                    <a href="/add-bank"><button type="button" className="btn btn"><span >Add Bank</span></button></a></div>
                    <div className="btn-group">
                    <a href="/add-deposit"><button type="button" className="btn btn"><span >Add Deposit</span></button></a></div>
                    <div className="btn-group">
                    <a href="/add-cheque"><button type="button" className="btn btn"><span >Add Cheque</span></button></a></div>
                    <div className="btn-group">
                    <a href="/account-report"><button type="button" className="btn btn"><span >Bank Statement</span></button></a></div>
                    </div>
                    </div>


               </div>
            </div>
        </section>
    )
}

export default AccountMenu;